
import iteratorsCommons from "@/components/UserInterfaces/renderer/mixins/iterators-commons";
import LineRenderer from "@/components/UserInterfaces/renderer/LineRenderer.vue";
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
    name: "BodyRenderer",
    components: { LineRenderer },
    mixins: [iteratorsCommons],
    props: {
        body: { type: Array, default: null },
        data: { type: Object, default: () => ({}) },
        path: { type: Array, default: () => [] },
        namespace: { type: String, default: "" },
        teleportTo: { type: String, default: "" }
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapState("components", ["designer", "elementState"]),
        ...mapGetters("components", ["getElementState"]),
        lines() {
            const lines = [];
            const line = [];

            this.body.forEach(entry => {
                const { generics } = this.getGenericsAndPropertiesByGuid(entry.guid);

                if (!generics) { return; }

                if (generics.share) {
                    line.push(entry);
                } else {
                    lines.push([...line.splice(0), entry]);
                }
            });

            if (line.length) {
                lines.push([...line.splice(0)]);
            }

            return lines;
        },
        filteredLines() {
            const filterVisible = ({ guid }) => {
                const state = this.getState(guid, this.namespace) || {};
                const { display = false } = state;

                return display;
            };

            return this.lines.map(line => line.filter(filterVisible));
        }
    },
    methods: {
        ...mapMutations("components", ["initElementState"]),
        getLineKey(idx) {
            return this.lines[idx].reduce((acc, { guid }) => (acc ? `${acc}_${guid}` : guid), "");
        },
        getState(guid, ns) {
            // if (this.designer) {
            if (this.designer) {
                return this.live ? this.getGenericsAndPropertiesByGuid(guid).generics : this.$store.state.components.defaultGenerics;
                // return this.$store.state.components.defaultGenerics;
            }

            const state = this.getElementState({ guid, ns });
            return state || this.initState(guid, ns);
        },
        initState(guid, ns) {
            this.initElementState({ ns, guid });
            return this.getElementState({ guid, ns });
        }
    }
};
